function isPreviousMonth(date: Date) {
  const now = new Date()

  if (date.getFullYear() < now.getFullYear()) {
    return true
  }

  return (
    date.getFullYear() === now.getFullYear() && date.getMonth() < now.getMonth()
  )
}

export { isPreviousMonth }
